<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>

  <div v-else>
    <div class="ui grid">
      <div class="right aligned column">
        <div
          class="ui very compact medium red button"
          style="background-color: #023d7e"
          @click="openModal('cancel-reservation')"
          v-if="reservationCanbeCancelledOrUpdated && ($auth.check('employee') || isAdmin())"
        >
          {{ $t('cancel') }}
        </div>

        <div 
          class="ui blue tiny button"
          style="background-color: #092442"
          v-if="reservationCanBeUpdated && ($auth.check('employee') || isAdmin())"
          @click="updateReservation()"
        >
          Update
        </div>
      </div>
    </div>

    <div class="ui segment" :class="reservation.cancelled_at ? 'red' : ''" style="padding-bottom: 30px">
      <h1
        class="ui header"
        style="text-align: center; text-decoration:underline; text-underline-position: under;"
      >
        {{ $t('reservation') }} # {{ reservation.id }} <span style="color:red"> {{ reservation.cancelled_at ?  'Cancelled' : ''}}</span>
      </h1>

      <reservationInfo  :reservation="reservation" />
     
      <br />

      <div 
        class="ui item menu"
        :class="{one: $auth.check('doctor') && !isAdmin(), three: isAdmin() || $auth.check('employee')}"
      >
        <a
          class="item" :class="{ active: currentTab === tabs.first }"
          @click="currentTab = tabs.first"
        >
          Packages
        </a>
        <a
          class="item" 
          :class="{ active: currentTab === tabs.second }"
          @click="currentTab = tabs.second"
          v-if="isAdmin() || $auth.check('employee')"
        >
          Visits
        </a>
        <a
          class="item" 
          :class="{ active: currentTab === tabs.third }"
          @click="currentTab = tabs.third"
          v-if="isAdmin() || $auth.check('employee')"
        >
          Transactions
        </a>
      </div>

      <div v-if="currentTab === tabs.first" style="margin-top: 20px">
        <PackagesPart
          :reservationId="reservation.id"
          :packageEntities="reservation.reservations_packages"
          :completePackages="reservation.packages"
          :cancelled="reservation.cancelled_at"
          :visits="reservation.visits"
        />
      </div>

      <div v-if="currentTab === tabs.second" style="margin-top: 20px">
        <div 
          class="ui blue button" 
          style="background-color: #092442; margin-bottom: 15px"
          @click="navigateTo('New_Visit', { key: 'params', value: { reservationId: reservation.id } })"
        >
          Add new visit
        </div>
        <div class="ui two columns grid">
          <div class="column" v-for="visit in visitsWithPackageNames" :key="visit.id">
            <showVisit
              class="ui clearing segment"
              :class="visitStatusColor(visit)"
              :visit="visit"
              :cancelled="reservation.cancelled_at"
              :key="'Visit' + visit.id"
            />
          </div>
        </div>
      </div>

      <div v-if="currentTab === tabs.third" style="margin-top: 10px">
        <transactionsPart
          :reservationId="reservation.id"
          :transactions="reservation.transactions"
          :reservationTransactions="reservation.reservation_transactions"
          :cancelled="reservation.cancelled_at"
          :packages="getTransactionPackages()"
          :clinicId="getClinicId()"
        />
      </div>
    </div>

    <div
      class="ui large longer modal"
      id="cancel-reservation"
      style="margin-top: 20px !important;"
    >
      <div class="header">
        {{ $t('reservationCancellation') }}
      </div>

      <div class="content">
        <div class="ui form">
          <div class="field">
            <label for="" style="font-size: 15px">
              {{ $t('cancellationReason') }}
              <span style="font-size: 10px; color:green;">{{
                $t('notRequired')
              }}</span>
            </label>
            <textarea
              rows="3"
              :placeholder="$t('cancellationReason')"
              v-model="reservationCancellation.cancellation_reason"
            />
          </div>
        </div>
      </div>

      <div class="actions">
        <div class="ui button" @click="discard('cancel-reservation')">
          {{ $t('discard') }}
        </div>
        <div
          class="ui blue button"
          style="background-color: #092442"
          @click="save('cancel-reservation')"
        >
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    PackagesPart: require('./reservation_components/PackagesPart').default,
    transactionsPart: require('./reservation_components/TransactionsPart').default,
    showVisit: require('./reservation_components/ShowVisit').default,
    reservationInfo: require('./reservation_components/ReservationInfo').default
  },
  data() {
    return {
      reservation: {},
      loading: true,
      tabs: {
        first: 'packages',
        second: 'visits',
        third: 'transactions'
      },
      currentTab: 'transactions',
      reservationCancellation: {
        cancelled_at: window.moment().toDate(),
        cancellation_fee: 0,
        cancellation_reason: null
      },
      transactionKey: 0
    };
  },
  computed: {
    reservationCancellationTable() {
      return {
        cancelled_at: this.cancelledAt,
        [this.$t('cancellationReason')]: this.cancellationReason
      };
    },
    cancelledAt() {
      return this.reservation.cancelled_at
        ? window.moment(this.reservation.cancelled_at).format('DD/MM/YYYY - hh:mm a')
        : '-';
    },
    cancellationReason() {
      return this.reservation.cancelled_at
        ? this.reservation.cancellation_reason : '-'
    },
    reservationCanbeCancelledOrUpdated() {
      if (this.reservation.cancelled_at) {
        return false;
      }
      let canBeCancelledOrUpdated = true;

      window._.each(this.reservation.visits, visit => {
        canBeCancelledOrUpdated =
          canBeCancelledOrUpdated &&
          !visit.started_at &&
          !visit.finished_at;
      });

      return canBeCancelledOrUpdated;
    },
    reservationCanBeUpdated() {
      if (this.reservation.cancelled_at) {
        return false;
      }
      return this.reservation.reservations_packages.filter(rp => Number(rp.remainder) > 0).length > 0
      // return this.reservation.visits.filter(visit => {
      //     return ![this.VisitStatuses.CANCELLED, this.VisitStatuses.FINISHED].includes(visit.visit_status_id)
      // }).length > 0
    },
    visitsWithPackageNames() {
      window._.each(this.reservation.visits, visit => {
        visit['reservationVisitId'] = this.getReservationVisitId(visit)
        visit['reservationId'] = this.reservation.id
        window._.each(visit.visit_details, visitDetail => {
          visitDetail['package_name'] = this.getPackageName(
            visitDetail.package_id
          );
          visitDetail['price'] = this.getPriceForVisitPackage(visitDetail);
        });
      });
      return this.reservation.visits;
    }
  },
  beforeMount() {
    this.axios.all([this.getReservation()]).then(
      this.axios.spread((reservationResponse) => {
        this.reservation = reservationResponse.data.reservation
        this.reservation.visits = reservationResponse.data.meta.visits
        this.reservation.packages = 
          this.reservation.reservations_packages.map(reservationPackage => reservationPackage.package)
        this.reservation.transactions = reservationResponse.data.meta.transactions
        this.loading = false;
      })
    );
  },
  methods: {
    getReservationVisitId(visit) {
      return this.reservation.reservation_visits.find(rv => {
        return rv.visit_id === visit.id && rv.clinic_id === visit.clinic_id
      }).id
    },
    getReservation() {
      return this.$http.get(`reservations/${this.$route.params.id}`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      });
    },
    openModal(modalId) {
      $(`#${modalId}`).modal('show');
    },
    discard(modalId) {
      $(`#${modalId}`).modal('hide');
      this.reservationCancellationTable = {
        cancelled_at: window.moment().toDate(),
        cancellation_fee: 0,
        cancellation_reason: null
      };
    },
    save(modalId) {
      this.$http
        .post(`reservations/${this.reservation.id}/cancel`, {
          ...this.reservationCancellation,
          clinic_id: this.getClinicId()
        })
        .then(response => {
          this.reservation.cancellation_fee = response.data.cancellation_fee;
          this.reservation.cancellation_reason =
            response.data.cancellation_reason;
          this.reservation.cancelled_at = response.data.cancelled_at;
          this.$forceUpdate();
          this.discard(modalId);
        });
    },
    getPackageName(packageId) {
      return window._.find(
        this.reservation.packages,
        slectedPackageEntity => {
          return slectedPackageEntity.id === packageId;
        }
      ).name;
    },
    getPriceForVisitPackage(visitDetail) {
      let selectedPackage = window._.find(
        this.reservation.packages,
        selectedPackageEntity => {
          return selectedPackageEntity.id === visitDetail.package_id;
        }
      );
      
      let unitPrice = Number(selectedPackage.unit_price);
      return Number(visitDetail.quantity) * unitPrice;
    },
    visitStatusColor(visit) {
      if (this.reservation.cancelled_at) { return 'red'; }

      if (visit.finished_at) { return 'green'; }

      if (window.moment().isAfter(visit.time)) {
        return 'black';
      }

      return 'orange';
    },
    getTransactionPackages() {
      return this.reservation.reservations_packages.map(rp => {
        return {
          id: rp.package_id,
          name: rp.package.name,
          remainder: this.packageTotalPrice(rp) - this.totalTransactionForPackage(rp)
        }
      })
      // .filter(p => p.remainder > 0)
    },
    packageTotalPrice(reservationPackage) {
      return Number(reservationPackage.repeated) * Number(reservationPackage.package.unit_price)
        * Number(reservationPackage.package.quantity)
    },
    totalTransactionForPackage(reservationPackage) {
      const transactionIds = this.reservation.reservation_transactions
        .filter(rt => rt.package_id === reservationPackage.package_id)
        .map(rt => rt.transaction_id)
        
      return window._.sumBy(this.reservation.transactions, transaction => {
        return transactionIds.includes(transaction.id) ? transaction.amount : 0
      })
    },
    updateReservation(){
      this.navigateTo('Update_Reservation', {
        key: 'params',
        value: {
          id: this.reservation.id
        }
      })
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reservations/Reservation.vue